import React from 'react';
import { Badge } from '../ui/badge';
import { LayoutGrid, CheckCircle2, XCircle } from 'lucide-react';

export default function AccommodationSummaryBar({ summary }) {
  if (!summary) return null;
  return (
    <div className="flex flex-wrap items-center gap-4 p-3 bg-white rounded-lg border text-sm" data-testid="accommodation-summary">
      <div className="flex items-center gap-1.5">
        <LayoutGrid className="h-4 w-4 text-gray-400" />
        <span className="font-medium">{summary.total_rows} rows</span>
      </div>
      <Badge variant="outline" className="bg-blue-50 text-blue-700 border-blue-200">
        {summary.total_area} m²
      </Badge>
      {summary.included_in_valuation > 0 && (
        <div className="flex items-center gap-1 text-green-600">
          <CheckCircle2 className="h-3.5 w-3.5" />
          <span>{summary.included_in_valuation} m² valued</span>
        </div>
      )}
      {summary.excluded_from_valuation > 0 && (
        <div className="flex items-center gap-1 text-gray-400">
          <XCircle className="h-3.5 w-3.5" />
          <span>{summary.excluded_from_valuation} m² excluded</span>
        </div>
      )}
      <Badge variant="outline" className="capitalize">
        {summary.property_mode} / {summary.measurement_method?.replace('_', ' ')}
      </Badge>
    </div>
  );
}
